// storybook-check-ignore
import { Box, Text } from '@opendoor/bricks-next';
import { Image } from '@opendoor/bricks/core';

import { ArticleProps } from '../../cms/index';
import { getArticleCategory } from '../../components/articles-v2/ArticleCard';

export const ArticleHeader = (props: ArticleProps) => {
  const articleCategory = getArticleCategory(props.sys.tags);

  // Only articles after the contentful migration will have a header image
  const headerImgUrl = props.fields?.headerImage?.fields.file?.url;
  const headerImgAlt =
    props.fields?.headerImage?.fields?.description || props.fields?.headerImage?.fields?.title;

  return (
    <>
      <Box
        marginBottom="$32x"
        $largerThanSM={{
          marginBottom: 90,
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Box
          $largerThanSM={{
            flexGrow: 12,
            flexShrink: 1,
            flexBasis: 12,
          }}
        >
          <Text
            tag="p"
            color="$contentSecondary"
            fontWeight="100"
            typography="$labelMedium"
            marginBottom="$12x"
          >
            {articleCategory}
          </Text>
          <Text tag="h1" typography="$headerLarge" $largerThanSM={{ typography: '$displayMedium' }}>
            {props.fields.articleName}
          </Text>
        </Box>
        <Box
          paddingLeft="$36x"
          display="none"
          $largerThanSM={{
            display: 'block',
          }}
        >
          {!props.fields.hideReadingTime && (
            <Text tag="p" color="$contentSecondary" typography="$labelMedium" marginBottom="$8x">
              Reading Time &mdash; {props.readingTimeMinutes} minutes
            </Text>
          )}
          {props.fields.publishDate && (
            <Text tag="p" typography="$bodyMedium">
              {new Date(props.fields.publishDate + 'T00:00:00').toLocaleDateString('en-us', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </Text>
          )}
        </Box>
      </Box>
      <Box
        $largerThanSM={{
          flexDirection: 'row',
        }}
        marginBottom={
          props.fields.keyTakeaways && props.fields.keyTakeaways?.content.length > 0 ? '$32x' : 0
        }
      >
        <Box
          marginBottom="$32x"
          $largerThanSM={{
            marginBottom: 0,
            flexGrow: 4,
            flexShrink: 1,
            flexBasis: 0,
          }}
        >
          {props.fields.articleSubtitle && (
            <Text tag="p" typography="$headerSmall" marginBottom="$8x">
              {props.fields.articleSubtitle}
            </Text>
          )}
          {props.fields.authors?.[0].fields.displayName && (
            <Text tag="p" typography="$bodyMedium" color="$contentSecondary">
              By {props.fields.authors?.[0].fields.displayName}
            </Text>
          )}
        </Box>
        {headerImgUrl && headerImgAlt && (
          <Box
            id="header-image"
            marginBottom={32}
            $largerThanSM={{
              marginBottom: 0,
              flexGrow: 8,
              flexShrink: 1,
              flexBasis: 0,
            }}
          >
            <Image
              src={headerImgUrl}
              alt={headerImgAlt}
              borderRadius="roundedSmooth"
              w="100%"
              h="auto"
            />
          </Box>
        )}
        <Box $largerThanSM={{ display: 'none' }}>
          {!props.fields.hideReadingTime && (
            <Text tag="p" typography="$bodyMedium" color="$contentSecondary" marginBottom="$8x">
              Reading Time &mdash; {props.readingTimeMinutes} minutes
            </Text>
          )}
          {props.fields.publishDate && (
            <Text tag="p" typography="$bodyMedium">
              {new Date(props.fields.publishDate + 'T00:00:00').toLocaleDateString('en-us', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </Text>
          )}
        </Box>
      </Box>
    </>
  );
};
